import * as React from 'react';
import { Box, createStyles } from '@mantine/core';
import { Outlet } from 'react-router-dom';

// Components
import { NavbarAdmin } from '../NavbarAdmin';
import { SignAgreement } from '../SignAgreement';

// Contexts
import { ViewingAsProvider } from '../../contexts/ViewingAs';
import { AuthContext } from '../../contexts/Auth';

// Types
import { UserTypes } from '../../types';

const useStyles = createStyles((theme) => {
    return {
        content: {
            [theme.fn.smallerThan('sm')]: {
                paddingTop: '3.7rem'
            }
        }
    };
});

export const AdminRouteWrapper: React.FC = () => {
    const { classes } = useStyles();
    const { authState } = React.useContext(AuthContext);
    const [signedAgreementModalOpen, setSignedAgreementModalOpen] = React.useState(false);

    return (
        <ViewingAsProvider userType={UserTypes.ADMIN}>
            <Box className={classes.content}>
                <NavbarAdmin />
                <Outlet />
                {!authState?.hasSignedAgreement || signedAgreementModalOpen ? (
                    <SignAgreement onToggle={setSignedAgreementModalOpen} />
                ) : null}
            </Box>
        </ViewingAsProvider>
    );
};

export default AdminRouteWrapper;
